<template>
  <div class="flex justify-between items-center mt-8">
    <div>
      <nav class="relative z-0 inline-flex shadow-sm">
        <button
          type="button"
          class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
          :class="{'bg-gray-200': isPreviousButtonDisabled}"
          aria-label="Previous"
          @click="previousPage"
          :disabled="isPreviousButtonDisabled"
        >
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <button
          type="button"
          :key="`page_${pageIndex}`"
          v-for="(pageNumber, pageIndex) in pages"
          @click="loadSelectedPage(pageNumber)"
          class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
          :class="[ pageNumber == currentPage ? 'bg-secundario border-secundario text-white hover:text-gray-300' : 'text-gray-700 hover:text-gray-500 ']"
        >
          {{ pageNumber }}
        </button>
        <button
          type="button"
          class="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
          :class="{'bg-gray-200': isNextButtonDisabled}"
          aria-label="Next"
          @click="nextPage"
          :disabled="isNextButtonDisabled"
        >
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </nav>
    </div>
    <div class="ml-2">
      <span>{{ $t("lang.msg.rowsPerPage") }}</span>
      <select
        v-model.number="visibleRowsSelected"
        @change="loadSelectedPage(1)"
        class="form-select w-20 h-8 ml-2 mr-4 py-1 pr-8 appearance-none rounded text-gray-900 placeholder-gray-500 leading-5 focus:outline-none focus:shadow-outline cursor-pointer"
      >
        <option :value="5">
          5
        </option>
        <option :value="10">
          10
        </option>
        <option :value="25">
          25
        </option>
        <option :value="totalRows">
          {{ $t('lang.msg.all') }}
        </option>
      </select>
      <span
        class="pl-4 border-l-2 border-gray-700 cursor-pointer"
        @click="visibleRowsSelected = totalRows"
      >{{ $t('lang.msg.viewAll') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanningPagination",
  emits: ['take-rows', 'next-page', 'load-selected-page', 'previous-page'],
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalRows: {
      type: Number,
      required: true
    },
    visibleRows: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      pages: [],
      pageCount: 1,
      visibleRowsSelected: 10
    };
  },
  created() {
    if (this.totalRows != 0) {
      this.setPages();
    }
  },
  computed: {
    isPreviousButtonDisabled() {
      return this.currentPage === 1;
    },
    isNextButtonDisabled() {
      return this.currentPage === this.pageCount;
    }
  },
  methods: {
    nextPage() {
      this.$emit("next-page");
    },
    loadSelectedPage(value) {
      this.$emit("load-selected-page", value);
    },
    previousPage() {
      this.$emit("previous-page");
    },
    setPages() {
      this.pages = [];
      this.pageCount = Math.ceil(this.totalRows / this.visibleRowsSelected);
      for (let index = 1; index <= this.pageCount; index++) {
        this.pages.push(index);
      }
    }
  },
  watch: {
    currentPage() {
      this.setPages();
    },
    totalRows() {
      this.setPages();
    },
    visibleRowsSelected() {
      this.setPages();
      this.$emit("take-rows", this.visibleRowsSelected);
    }
  }
};
</script>
